import React, { useState } from "react";
import { Button } from "../components/ui/button";
import TeamUtilizationSection from "../components/TeamUtilizationSection";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * /team-utilization — standalone team utilization & KPI page (admin, pm_lead,
 * finance). Same component as the owner-dashboard block, plus a month switcher,
 * so the PM lead can work with it without owner-dashboard access.
 */
const TeamUtilizationPage = () => {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);

  const prevMonth = () => {
    if (month === 1) { setYear(year - 1); setMonth(12); } else setMonth(month - 1);
  };
  const nextMonth = () => {
    if (month === 12) { setYear(year + 1); setMonth(1); } else setMonth(month + 1);
  };

  return (
    <div className="p-6 space-y-4 max-w-[1600px] mx-auto">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-zinc-50 font-['Manrope']">Team utilization & KPI</h1>
          <p className="text-sm text-zinc-500">
            Worksection hours vs portal projects · who's loaded, what it costs, what it brings
          </p>
        </div>
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="icon" className="h-8 w-8 text-zinc-400" onClick={prevMonth}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="text-sm text-zinc-50 font-mono w-24 text-center">
            {MONTH_NAMES[month - 1]} {year}
          </span>
          <Button variant="ghost" size="icon" className="h-8 w-8 text-zinc-400" onClick={nextMonth}>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <TeamUtilizationSection year={year} month={month} />
    </div>
  );
};

export default TeamUtilizationPage;
